<template>
  <div>
    <b-form-group label="Nome Fantasia:">
      <b-form-input
        v-model="legal_person.fantasy_name"
        placeholder="Nome"
        :state="validateState('fantasy_name')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Razão Social:">
      <b-form-input
        v-model="legal_person.social_reason"
        placeholder="Razão Social"
        :state="validateState('social_reason')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Razão Social é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="CNPJ:">
      <b-form-input
        v-model="cnpj"
        placeholder="CNPJ"
        :formatter="formatterCnpj"
        :state="validateState('cnpj')"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.legal_person.cnpj.required"
          >CNPJ é um campo obrigatório.</span
        >
        <span v-if="!$v.legal_person.cnpj.cnpj">CNPJ inválido</span>
        <span v-if="!$v.legal_person.cnpj.is_unique"
          >CNPJ já está em uso por outra pessoa jurídica</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Inscrição Estadual:">
      <b-form-input v-model="legal_person.ie" placeholder="IE"></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cnpj } from "cpf-cnpj-validator";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  props: {
    cnpj_invalid: {
      default: null,
    },
  },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    legal_person: {
      social_reason: {
        required,
        minLength: minLength(3),
      },
      fantasy_name: {
        required,
        minLength: minLength(3),
      },
      cnpj: {
        cnpj: (value) => {
          return !value || cnpj.isValid(value);
        },
        is_unique(value) {
          return value != this.cnpj_invalid;
        },
      },
    },
  },
  computed: {
    ...mapState("legal_people", ["legal_person"]),
    cnpj: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 14);
        this.legal_person.cnpj = value;
      },
      get() {
        let value = this.legal_person.cnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
        return value;
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.legal_person[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.legal_person.$touch();
      return !this.$v.legal_person.$anyError;
    },
    formatterCnpj(value) {
      value = value.replace(/\D/g, "").substring(0, 14);
      value = value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
      return value;
    },
  },
  created() {},
  directives: { mask },
};
</script>
